import { FlexBox, MEDIA } from "@brg/ui";
import { FC, useMemo } from "react";
import styled from "styled-components";

interface BroadCastViewProps {
    broadcastLink?: string | null;
}

const PlayerContainer = styled.div`
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    iframe,
    video {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
`;

const InvalidLinkMessage = styled.div`
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme?.text?.secondary ?? '#707070'};
    word-break: break-word;
`;

const getYouTubeVideoId = (url: string): string => {
    const embedId = url.match(/(?:youtube\.com|youtube-nocookie\.com)\/embed\/([\w-]{6,})/)?.[1];
    if (embedId) return embedId;

    const watchId = url.match(/[?&]v=([\w-]{6,})/)?.[1];
    if (watchId) return watchId;

    const shortId = url.match(/youtu\.be\/([\w-]{6,})/)?.[1];
    if (shortId) return shortId;

    const shortsId = url.match(/youtube\.com\/shorts\/([\w-]{6,})/)?.[1];
    if (shortsId) return shortsId;

    const liveId = url.match(/youtube\.com\/live\/([\w-]{6,})/)?.[1];
    if (liveId) return liveId;

    return '';
};

const getVkVideoEmbedSrc = (url: string): string | null => {
    const raw = url.trim();

    const vkVideoMatch = raw.match(/(?:vkvideo\.(?:ru|com)|vk\.(?:com|ru))\/video(-?\d+)_(\d+)/)
        ?? raw.match(/(?:^|\/)video(-?\d+)_(\d+)/);
    const oidFromPath = vkVideoMatch?.[1];
    const videoIdFromPath = vkVideoMatch?.[2];

    const extMatch = raw.match(/[?&]oid=(-?\d+).*?[?&]id=(\d+)(?:.*?[?&]hash=([\w-]+))?/);
    const oid = extMatch?.[1] ?? oidFromPath ?? '';
    const hash = extMatch?.[3];
    const videoId = videoIdFromPath ?? extMatch?.[2];

    if (!oid || !videoId) return null;

    const base = /vk\.(?:com|ru)/i.test(raw) ? 'https://vk.com' : 'https://vkvideo.ru';
    const hashPart = hash ? `&hash=${hash}` : '';

    return `${base}/video_ext.php?oid=${oid}&id=${videoId}${hashPart}&autoplay=0`;
};

const getBroadcastEmbedSrc = (url: string): string | null => {
    const trimmed = url.trim();
    if (!trimmed) return null;

    const iframeSrc = trimmed.match(/src=["']([^"']+)["']/)?.[1];
    const raw = iframeSrc || trimmed;

    const ytId = getYouTubeVideoId(raw);
    if (ytId) {
        return `https://www.youtube-nocookie.com/embed/${ytId}?rel=0&modestbranding=1`;
    }

    const kinescopeId = raw.match(
        /(?:https?:\/\/(?:www\.)?kinescope\.io\/(?:embed\/)?|<iframe[^>]+src=["']?https?:\/\/kinescope\.io\/embed\/)([\w-]+)/,
    )?.[1];
    if (kinescopeId) {
        return `https://kinescope.io/embed/${kinescopeId}`;
    }

    const vimeoId = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
    if (vimeoId) {
        return `https://player.vimeo.com/video/${vimeoId}`;
    }

    const rutubeId = raw.match(/rutube\.ru\/(?:video|play\/embed)\/([\w-]+)/)?.[1];
    if (rutubeId) {
        return `https://rutube.ru/play/embed/${rutubeId}`;
    }

    if (/vkvideo\.(?:ru|com)|vk\.(?:com|ru)/i.test(raw)) {
        return getVkVideoEmbedSrc(raw);
    }

    if (isDirectVideo(raw)) {
        return raw;
    }

    return null;
};

const isDirectVideo = (src: string) => /\.(mp4|webm|ogg|mov)(\?|$)/i.test(src);

export const BroadCastView: FC<BroadCastViewProps> = ({ broadcastLink }) => {
    const rawLink = (broadcastLink ?? '').trim();

    const src = useMemo(
        () => getBroadcastEmbedSrc(rawLink),
        [rawLink],
    );

    if (!rawLink) return null;

    if (!src) {
        return (
            <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
                <InvalidLinkMessage>
                    Некорректная ссылка
                    <br />
                    {rawLink}
                </InvalidLinkMessage>
            </FlexBox>
        );
    }

    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <PlayerContainer>
                {isDirectVideo(src) ? (
                    <video src={src} controls />
                ) : (
                    <iframe
                        src={src}
                        title="Broadcast"
                        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write"
                        allowFullScreen
                    />
                )}
            </PlayerContainer>
        </FlexBox>
    );
};
import { FlexBox, MEDIA } from "@brg/ui";
import { FC, useMemo } from "react";
import styled from "styled-components";

interface BroadCastViewProps {
    broadcastLink?: string | null;
}

const PlayerContainer = styled.div`
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    iframe,
    video {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
`;

const InvalidLinkMessage = styled.div`
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme?.text?.secondary ?? '#707070'};
    word-break: break-word;
`;

const getYouTubeVideoId = (url: string): string => {
    const embedId = url.match(/(?:youtube\.com|youtube-nocookie\.com)\/embed\/([\w-]{6,})/)?.[1];
    if (embedId) return embedId;

    const watchId = url.match(/[?&]v=([\w-]{6,})/)?.[1];
    if (watchId) return watchId;

    const shortId = url.match(/youtu\.be\/([\w-]{6,})/)?.[1];
    if (shortId) return shortId;

    const shortsId = url.match(/youtube\.com\/shorts\/([\w-]{6,})/)?.[1];
    if (shortsId) return shortsId;

    const liveId = url.match(/youtube\.com\/live\/([\w-]{6,})/)?.[1];
    if (liveId) return liveId;

    return '';
};

const getVkVideoEmbedSrc = (url: string): string | null => {
    const raw = url.trim();

    const vkVideoMatch = raw.match(/(?:vkvideo\.(?:ru|com)|vk\.(?:com|ru))\/video(-?\d+)_(\d+)/)
        ?? raw.match(/(?:^|\/)video(-?\d+)_(\d+)/);
    const oidFromPath = vkVideoMatch?.[1];
    const videoIdFromPath = vkVideoMatch?.[2];

    const extMatch = raw.match(/[?&]oid=(-?\d+).*?[?&]id=(\d+)(?:.*?[?&]hash=([\w-]+))?/);
    const oid = extMatch?.[1] ?? oidFromPath ?? '';
    const hash = extMatch?.[3];
    const videoId = videoIdFromPath ?? extMatch?.[2];

    if (!oid || !videoId) return null;

    const base = /vk\.(?:com|ru)/i.test(raw) ? 'https://vk.com' : 'https://vkvideo.ru';
    const hashPart = hash ? `&hash=${hash}` : '';

    return `${base}/video_ext.php?oid=${oid}&id=${videoId}${hashPart}&autoplay=0`;
};

const getBroadcastEmbedSrc = (url: string): string | null => {
    const trimmed = url.trim();
    if (!trimmed) return null;

    const iframeSrc = trimmed.match(/src=["']([^"']+)["']/)?.[1];
    const raw = iframeSrc || trimmed;

    const ytId = getYouTubeVideoId(raw);
    if (ytId) {
        return `https://www.youtube-nocookie.com/embed/${ytId}?rel=0&modestbranding=1`;
    }

    const kinescopeId = raw.match(
        /(?:https?:\/\/(?:www\.)?kinescope\.io\/(?:embed\/)?|<iframe[^>]+src=["']?https?:\/\/kinescope\.io\/embed\/)([\w-]+)/,
    )?.[1];
    if (kinescopeId) {
        return `https://kinescope.io/embed/${kinescopeId}`;
    }

    const vimeoId = raw.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
    if (vimeoId) {
        return `https://player.vimeo.com/video/${vimeoId}`;
    }

    const rutubeId = raw.match(/rutube\.ru\/(?:video|play\/embed)\/([\w-]+)/)?.[1];
    if (rutubeId) {
        return `https://rutube.ru/play/embed/${rutubeId}`;
    }

    if (/vkvideo\.(?:ru|com)|vk\.(?:com|ru)/i.test(raw)) {
        return getVkVideoEmbedSrc(raw);
    }

    if (isDirectVideo(raw)) {
        return raw;
    }

    return null;
};

const isDirectVideo = (src: string) => /\.(mp4|webm|ogg|mov)(\?|$)/i.test(src);

export const BroadCastView: FC<BroadCastViewProps> = ({ broadcastLink }) => {
    const rawLink = (broadcastLink ?? '').trim();

    const src = useMemo(
        () => getBroadcastEmbedSrc(rawLink),
        [rawLink],
    );

    if (!rawLink) return null;

    if (!src) {
        return (
            <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
                <InvalidLinkMessage>
                    Некорректная ссылка
                    <br />
                    {rawLink}
                </InvalidLinkMessage>
            </FlexBox>
        );
    }

    return (
        <FlexBox direction="column" directionMobile="column" gy={40} flex="1">
            <PlayerContainer>
                {isDirectVideo(src) ? (
                    <video src={src} controls />
                ) : (
                    <iframe
                        src={src}
                        title="Broadcast"
                        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write"
                        allowFullScreen
                    />
                )}
            </PlayerContainer>
        </FlexBox>
    );
};
